export class Metadata {
    public size: string;
    public displayName: string;

    public constructor(size: string, displayName: string) {
        this.size = size;
        this.displayName = displayName;
    }
}
